const it = {
    company: {
        label: 'Azienda',
        createCompany: 'Crea Nuova Azienda',
        switchCompany: 'Cambia Azienda',
        address: 'Indirizzo',
        profile: 'Profilo',
        list: 'Elenco Aziende',
        listCompanySubTitle: 'Elenco delle aziende per tipo di profilo',
        listCompanyCount: 'Numero',
        companyName: 'Denominazione',
        companyDetails: 'Dettagli Azienda',
        email: 'Email',
        fiscalEmail: 'PEC',
        logo: 'Logo Azienda',
        streetName: 'Indirizzo',
        city: 'Città',
        province: 'Provincia',
        zipCode: 'CAP',
        vatCode: 'Partita IVA',
        vatCodeShort: 'P.IVA',
        fiscalCode: 'Codice Fiscale',
        fiscalCodeShort: 'C.F.',
        billingId: 'Codice Fatturazione(SDI)',
        mobile: 'Telefono',
        discount1: 'Sconto 1 (%)',
        discount2: 'Sconto 2 (%)',
        discount3: 'Sconto 3 (%)',
        transportLocation: 'Luogo di Trasporto',

        insertData: 'Inserisci i dati',
        authProfile: {
            label: 'Profilo',
            labelExtended: 'Profilo Azienda',
            CLIENT: 'Rivenditore',
            MANAGER: 'Gestore',
            SELLER: 'Agente',
        },
        listCompanyTitle: {
            CLIENT: 'Elenco Aziende Rivenditore',
            MANAGER: 'Elenco Aziende Gestore',
            SELLER: 'Elenco Aziende Agente',
        },
        tabName: {
            CLIENT: 'Rivenditori',
            MANAGER: 'Gestori',
            SELLER: 'Agenti',
        }



    },
    companyLink: {
        label: 'Collegamento Azienda',
        connect: 'Collega Aziende',
        mutateSubtitle: 'Modifica i dati del collegamento tra aziende',
        list: 'Elenco Aziende Collegate',
        listCompanyLinkSubTitle: 'Elenco dei collegamenti tra aziende',
        companyFrom: 'Azienda Da',
        companyTo: 'Azienda A',
        linkType: 'Tipo di Collegamento',
        sellerClient: 'Agente - Rivenditore',
        insertData: 'Inserisci i dati del collegamento',
    },
}
export default it
